import React from "react";
import { Row, Col } from "react-bootstrap";
import Contact from "../Contact/Contact";
import "./Footer.css";
import ScrollToTop from "react-scroll-to-top";
import Social from "./Social";
import socialIcon from "./../../images/icons/social-media-big.gif";
import logoMail from "./../../images/icons/gmail-logo.gif";
import logoRocket from "./../../images/icons/rocket1.gif";
import logo from "./../../images/icons/got.gif";

const Footer = () => {
  return (
    <Row className="w-100 footer pt-5">
      <ScrollToTop smooth top="1000" width="20" color="#20DBF0" />
      <Col className="footer-half" sm={6}></Col>
      <Col className="" sm={6}>
        <div className=" d-flex justify-content-center align-items-center">
          <h3 className="text-center py-3 ">Contact Me</h3>
          <img className="ms-1" src={logoRocket} width="60px" alt="" />
        </div>
        <Contact></Contact>
        <h4 className="mb-2">
          Or, direct mail me
          <a
            className="resume_button ms-2"
            href="mailto:shahriar.ahmod23@gmail.com"
          >
            <img className="me-1 pb-2" src={logoMail} width="25px" alt="" />
            Here
          </a>
        </h4>
      </Col>

      <div className="mt-5">
        <h3 className="text-center my-3">
          Find Me on Social Media{" "}
          <img className="ms-1 pb-1" src={socialIcon} width="55px" alt="" />
        </h3>

        <Social></Social>
        <h6 className="text-center mt-3">
          Copyright <i class="far fa-copyright"></i> {new Date().getFullYear()}{" "}
          by <span className="text-success">Shahriar</span> All Rights Reserved<img className="ms-1" src={logo} width="40px" alt="" />
        </h6>
      </div>
    </Row>
  );
};

export default Footer;
